/** Only include `srcSet` if `retina` value is available */
export const resolveSrcSet = (src: string, retina?: string | null) => ({
  ...(retina && { srcSet: `${src} 1x${retina ? `, ${retina} 2x` : ""}` }),
});
